import Theme from "./types/Theme";

const defaultTheme: Theme = {};

export default defaultTheme;
